jQuery(function ($) {
    AOS.init();
    
    
    // ps: disable on small devices!
    var $animationElements = $('.singleDescription');
    var $window = $(window);

    // ps: Let's FIRST disable triggering on small devices!
    var isMobile = window.matchMedia("only screen and (max-width: 768px)");
    if (isMobile.matches) {
        $animationElements.removeClass('animation-element');
    }

    function checkIfInView() {

        var windowHeight = $window.height();
        var windowTopPosition = $window.scrollTop();
        var windowBottomPosition = (windowTopPosition + windowHeight);

        $.each($animationElements, function () {
            var $element = $(this);
            var elementHeight = $element.outerHeight();
            var elementTopPosition = $element.offset().top;
            var elementBottomPosition = (elementTopPosition + elementHeight);

            //check to see if this current container is within viewport
            if ((elementBottomPosition >= windowTopPosition) &&
                (elementTopPosition <= windowBottomPosition)) {
                setTimeout(function(){
                    $element.addClass('in-view');
                }, 500);
            } else {
                $element.removeClass('in-view');
            }
        });
    }

    $window.on('scroll resize', checkIfInView);
    $window.trigger('scroll');

    
    var mySwiper = new Swiper ('.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        draggable: false,
        autoplay: {
            delay: 5000,
        },
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    })
    
    
    var scrollBtn = $('#scrollDown');
    
    scrollBtn.on( "click", function() {
        window.scrollTo({ top: $(window).height(), behavior: "smooth"});
    });
	
	
	if ($('#map').length) {
		mapboxgl.accessToken = 'pk.eyJ1Ijoibmljb3JlaXJnZW4iLCJhIjoiY2s5bXpkZHIxMDRkZjNoa3RmdjJuZXh4MiJ9.04bFXn9zA4wvgdK6fJ3-AA';

		var map = new mapboxgl.Map({
			container: 'map',
			style: 'mapbox://styles/mapbox/streets-v11',
			center: [3.082982,50.750187],
			zoom: 13
		});

		var geojson = {
			type: 'FeatureCollection',
			features: [{
				type: 'Feature',
				geometry: {
					type: 'Point',
					coordinates: [3.082982,50.750187]
				},
				properties: {
					title: 'Mapbox',
					description: 'Washington, D.C.'
				}
			}]
		};

		geojson.features.forEach(function (marker) {
			var el = document.createElement('div');
			el.className = 'marker';

			new mapboxgl.Marker(el)
				.setLngLat(marker.geometry.coordinates)
				.addTo(map);
		});

		map.addControl(new mapboxgl.NavigationControl());
    }
	
	
	
	var btn = $('#btt');

	$(window).scroll(function () {
		if ($(window).scrollTop() > 300) {
			btn.addClass('show');
		} else {
			btn.removeClass('show');
		}
	});

	btn.on('click', function (e) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: 0
		}, '300');
	});

	
	var cookieBox = document.getElementById('js-cookie-box');
	var cookieButton = document.getElementById('js-cookie-button');

	if (!Cookies.get('cookie-box')) {

		cookieBox.classList.remove('cookie-box--hide');

		cookieButton.onclick = function () {
			Cookies.set('cookie-box', true, {
				expires: 7
			});
			cookieBox.classList.add('cookie-box--hide');
		}
	}

	var clickDelay = 500,
		clickDelayTimer = null;

	$('.burger-click-region').on('click', function () {
		if (clickDelayTimer === null) {
			var $burger = $(this);
			$burger.toggleClass('active');
			$burger.closest('nav').toggleClass('is-open');

			if (!$burger.hasClass('active')) {
				$burger.addClass('closing');
			}

			clickDelayTimer = setTimeout(function () {
				$burger.removeClass('closing');
				clearTimeout(clickDelayTimer);
				clickDelayTimer = null;
			}, clickDelay);
		}
	});
});